$(document).ready(function(){
  if ($(window).width() < 750) {
    var elem = document.querySelector('.devCollectionSlider');
    var flkty = new Flickity( elem, {
      // options
      contain: true
    });
  }

  $('.tabs-wrapper.productTabsWrapper .rte.tab-content.tab-content-0').addClass('current');
  $('.tabs-wrapper.productTabsWrapper .tab-link.tab-link-0').addClass('current');
  
  
  $('.hc-items-wrapper .hc-option').on('click', function(){
    $(this).addClass('selected');
    $(this).siblings('.hc-option').removeClass('selected');
  });
 
});